const RefreshIcon = ({ className }: { className?: string }) => {
    return (
        <svg className={className} width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
                d="M6.5 4C4.088 5.378 2.5 8.024 2.5 11C2.5 13.1217 3.34285 15.1566 4.84315 16.6569C6.34344 18.1571 8.37827 19 10.5 19M14.5 18C16.787 16.592 18.5 13.882 18.5 11C18.5 8.87827 17.6571 6.84344 16.1569 5.34315C14.6566 3.84285 12.6217 3 10.5 3" 
                stroke="currentFill"
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M6.5 8V4H2.5M14.5 14V18H18.5" 
                stroke="currentFill"
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default RefreshIcon;